import React from "react";
import './App.css'
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SignUp from "./pages/SignUp/SignUp";
import LoginPage from './pages/login/login'
import ForgetPassword from './pages/forgetpassword/forgetPassword';
function App() {
  const [ darkMode, setDarkMode ] = React.useState(false)
  React.useEffect(() => {
    const body = document.body
    const toggle = document.querySelector('.toggle-inner')
  
    if( darkMode === true ) {
      body.classList.add('dark-mode')
      toggle.classList.add('toggle-active')
      document.getElementById("toggle").style.backgroundImage ="url(https://i.ibb.co/tH3T9Sm/sun.png)";
      document.getElementById("toggle").style.backgroundSize = "cover";
      document.getElementById("toggle").style.backgroundColor="#fff";
    } 
    else {
      body.classList.remove('dark-mode')
      toggle.classList.remove('toggle-active')
      document.getElementById("toggle").style.background ="url(https://i.ibb.co/pKMvGb7/moon.png)";
      document.getElementById("toggle").style.backgroundSize = "cover";
      document.getElementById("toggle").style.backgroundColor="#157ae1";
  
    }
  }, [darkMode])
  return (
    <div >
      <div >
<div id="toggleContainer" className='toggle-inner ' style={{paddingBottom:"20px"}}>
          <div  id="toggle"  onClick={() => darkMode === false ? setDarkMode(true) : setDarkMode(false)} className="toggle-inner">
          </div>
          </div>
          </div>
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgetpassword" element={<ForgetPassword />} />
      </Routes>
    </div>
  );
}

export default App;
